import { z } from 'zod';
import { IdSchema, MoneySchema } from './common.js';

const NoteSchema = z.string().trim().max(500).default('');

// ----- Cartera del crédito directo (Etapa 2) -----
export const CreditStatusSchema = z.enum(['OPEN', 'PAID', 'REVERSED']);

export const CreditAccountSchema = z.object({
  id: z.number().int(),
  sale_document_id: z.number().int(),
  sale_no: z.string(),
  location_id: z.number().int(),
  location_code: z.string(),
  location_name: z.string(),
  customer_name: z.string(),
  customer_document: z.string(),
  customer_phone: z.string(),
  financed_amount: z.number(),
  balance: z.number(),
  paid: z.number(),
  status: CreditStatusSchema,
  due_date: z.string().nullable(),
  days_overdue: z.number().int(),
  sold_at: z.string(),
  sold_by_name: z.string().nullable(),
  last_payment_at: z.string().nullable(),
  created_at: z.string(),
  reversed_at: z.string().nullable(),
  balance_before_reversal: z.number().nullable(),
});
export type CreditAccount = z.infer<typeof CreditAccountSchema>;

export const CreditTransactionSchema = z.object({
  id: z.number().int(),
  credit_account_id: z.number().int(),
  kind: z.enum(['PAYMENT', 'ADJUSTMENT']),
  amount: z.number(),
  note: z.string(),
  created_at: z.string(),
  user_id: z.number().int(),
  user_name: z.string().nullable(),
  document_id: z.number().int().nullable(),
  doc_no: z.string().nullable(),
  doc_status: z.string(),
  payment_method_id: z.number().int().nullable(),
  payment_method_name: z.string().nullable(),
  payment_method_kind: z.string().nullable(),
});
export type CreditTransaction = z.infer<typeof CreditTransactionSchema>;

export const CreditQuerySchema = z.object({
  status: CreditStatusSchema.optional(),
  location_id: IdSchema.optional(),
  /** Cliente, documento, teléfono o número de la venta. */
  q: z.string().trim().max(80).optional(),
  overdue: z.enum(['true', 'false']).default('false').transform((v) => v === 'true'),
  limit: z.coerce.number().int().min(1).max(500).default(100),
  offset: z.coerce.number().int().min(0).default(0),
});

export const CreditPaymentBodySchema = z.object({
  amount: MoneySchema.refine((v) => v > 0, 'INVALID_AMOUNT'),
  payment_method_id: IdSchema,
  note: NoteSchema,
});
export type CreditPaymentBody = z.input<typeof CreditPaymentBodySchema>;

export const CreditPaymentResultSchema = z.object({
  document_id: z.number().int(),
  doc_no: z.string(),
  status: z.string(),
  credit_account_id: z.number().int(),
  balance: z.number(),
  paid: z.boolean(),
});

export const DueDateBodySchema = z.object({ due_date: z.string().date().nullable() });
